import {
	Settings as SettingsIcon,
	Cloud as CloudStorageIcon,
	ChevronLeft as ChevronLeftIcon,
	Dashboard as DashboardIcon,
	VideogameAsset as VideoGameIcon,
	BugReport as BugIcon,
	Block as BlockIcon,
	Save as SaveIcon,
	PersonAdd as PersonAddIcon,
	Code as CodeIcon,
	ExpandLess as ExpandLessIcon,
	FileCopy as CopyContent,
	GetApp as GetAppIcon,
	Publish as PublishIcon,
	GTranslate as GTranslateIcon,
	RawOn as RawOnIcon,
	Extension as ExtensionIcon,
	CloudDownload as CloudDownloadIcon,
	Delete as DeleteIcon,
	ArrowDropDown as ArrowDropDownIcon,
	ArrowDropUp as ArrowDropUpIcon,
	Storage as StorageIcon,
	Memory as MemoryIcon,
	Search as SearchIcon,
	EditOutlined as EditOutlinedIcon,
	DoneOutlined as DoneOutlinedIcon,
} from "@mui/icons-material";

const icons = {
	Settings: SettingsIcon,
	GerverCluster: CloudStorageIcon,
	// SolrCluster: CloudStorageIcon,
	// CloudStorage: CloudStorageIcon,
	ChevronLeft: ChevronLeftIcon,
	Dashboard: DashboardIcon,
	Playground: VideoGameIcon,
	Log: BugIcon,
	Block: BlockIcon,
	Save: SaveIcon,
	PersonAdd: PersonAddIcon,
	TEditor: CodeIcon,
	ExpandLess: ExpandLessIcon,
	CopyContent: CopyContent,
	Download: GetAppIcon,
	Upload: PublishIcon,
	Localization: GTranslateIcon,
	RawOn: RawOnIcon,
	Extension: ExtensionIcon,
	CloudDownload: CloudDownloadIcon,
	Delete: DeleteIcon,
	ArrowDown: ArrowDropDownIcon,
	ArrowUp: ArrowDropUpIcon,
	Storage: StorageIcon,
	FirmwareGroup: MemoryIcon,
	Search: SearchIcon,
	Edit: EditOutlinedIcon,
	Done: DoneOutlinedIcon,
} as const;

export default icons;
